import React, { useEffect, useRef } from 'react';
import { AvailableIcons, Button, ConfirmationDialog, Icon } from 'src/components-dummy';
import { ButtonsContainer } from 'src/components-dummy/ConfirmationDialog/ConfirmationDialog.style';
import './StopExperimentModal.scss';

export interface StopExperimentModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}

const SIDE_EFFECTS = [
  'New sessions will get the default shop configuration',
  'Results collected so far are preserved and viewable',
  'Variant configurations remain saved but inactive',
  'The test cannot be resumed',
];

export const StopExperimentModal = ({
  onConfirm,
  onCancel,
}: StopExperimentModalProps): JSX.Element => {
  const cancelButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    cancelButtonRef.current?.focus();
  }, []);

  return (
    <ConfirmationDialog onCancel={onCancel} disableAutoFocus>
      <ConfirmationDialog.Header>
        <ConfirmationDialog.Title>Stop this experiment?</ConfirmationDialog.Title>
        <span
          role='button'
          tabIndex={0}
          onKeyDown={ev => {
            if (ev.key === 'Enter' || ev.key === ' ') {
              ev.preventDefault();
              onCancel();
            }
          }}
        >
          <Icon name={AvailableIcons.Close} onClick={onCancel} />
        </span>
      </ConfirmationDialog.Header>
      <ConfirmationDialog.Content>
        <ConfirmationDialog.ContentMainText>
          This will route new traffic back to the default configuration. This action cannot be
          undone.
        </ConfirmationDialog.ContentMainText>
        <ul className='stop-experiment-modal-side-effects'>
          {SIDE_EFFECTS.map(effect => (
            <li key={effect}>{effect}</li>
          ))}
        </ul>
      </ConfirmationDialog.Content>
      <ConfirmationDialog.Footer>
        <ButtonsContainer>
          <Button variant='destructive' onClick={onConfirm}>
            Stop experiment
          </Button>
          <Button ref={cancelButtonRef} variant='outlined' onClick={onCancel}>
            Cancel
          </Button>
        </ButtonsContainer>
      </ConfirmationDialog.Footer>
    </ConfirmationDialog>
  );
};
